<template>
    <div class="container">
        <div class="row">
            <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
                <div class="sidebar-header">
                    <a class="vik-brand" href="#">
                        <img src="@/assets/logo.svg" alt />
                    </a>
                    <div id="dismissSidebar">
                        <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
                            class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
                            <path d="M1 1L23 23M1 23L23 1" />
                        </svg>
                    </div>
                </div>

                <div class="category-list">
                    <h2>Templates</h2>
                    <p class="not-available" style="color: #8e8e8e; margin-top: 15px">
                        <i>no templates</i>
                    </p>
                </div>
            </div>
            <div class="col-md-8 col-lg-8 col-xl-8">
                <div class="content">
                    <div class="content new-item">
                        <h2 class="block-title" style="margin-bottom: 30px" v-if="isNew">New template</h2>
                        <h2 class="block-title" style="margin-bottom: 30px" v-else>{{ form.name }}</h2>
                        <el-form ref="templateform" label-position="top" :model="form" @submit.native.prevent>
                            <el-form-item prop="name" label="Name" :rules="[
                                {
                                    required: true,
                                    message: 'Please input template name',
                                    trigger: 'blur',
                                },
                            ]">
                                <input name="name" type="text" v-model="form.name" class="form-control"
                                    placeholder="For example: my server ports scan" />
                            </el-form-item>
                            <el-form-item label="Description">
                                <el-input v-model="form.description" type="textarea" :rows="3"
                                    placeholder="Описание"></el-input>
                            </el-form-item>
                            <el-form-item label="Public">
                                <el-switch v-model="form.public" />
                            </el-form-item>
                            <el-form-item label="Slug" v-if="form.public">
                                <el-input v-model="form.slug" placeholder="my-server-ports-scan" />
                            </el-form-item>
                            <el-form-item label="System">
                                <el-switch v-model="form.system" />
                            </el-form-item>
                            <el-form-item label="Tags">
                                <!-- <el-input v-model="form.tags" placeholder="tag1,tag2,tag3" /> -->
                                <el-select v-model="form.tags" multiple filterable allow-create default-first-option
                                    placeholder="Choose tags for your template">
                                </el-select>
                            </el-form-item>

                            <el-form-item label="Translations">
                                <div class="translations-section">
                                    <div v-for="(translation, index) in translations" :key="index" class="translation-item">
                                        <div class="translation-header">
                                            <el-select v-model="translation.lang" filterable placeholder="Select language" 
                                                style="width: 200px; margin-right: 10px;">
                                                <el-option label="English" value="en"></el-option>
                                                <el-option label="Russian" value="ru"></el-option>
                                                <el-option label="Spanish" value="es"></el-option>
                                                <el-option label="French" value="fr"></el-option>
                                                <el-option label="German" value="de"></el-option>
                                                <el-option label="Chinese" value="zh"></el-option>
                                                <el-option label="Japanese" value="ja"></el-option>
                                                <el-option label="Korean" value="ko"></el-option>
                                            </el-select>
                                            <button type="button" class="btn btn-sm btn-icon del" @click="removeTranslation(index)">
                                                <i class="vik vik-delete"></i>
                                            </button>
                                        </div>
                                        <div v-if="translation.lang" class="translation-fields">
                                            <el-form-item label="Name">
                                                <input type="text" v-model="translation.name" class="form-control"
                                                    :placeholder="'Translated name for ' + translation.lang" />
                                            </el-form-item>
                                            <el-form-item label="Description">
                                                <el-input v-model="translation.description" type="textarea" :rows="3"
                                                    :placeholder="'Translated description for ' + translation.lang"></el-input>
                                            </el-form-item>
                                            <el-form-item label="Tags">
                                                <el-select v-model="translation.tags" multiple filterable allow-create default-first-option
                                                    :placeholder="'Translated tags for ' + translation.lang">
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-primary" @click="addTranslation">
                                        <i class="vik vik-plus"></i>Add Translation
                                    </button>
                                </div>
                            </el-form-item>

                            <el-form-item label="Atoms" prop="atoms"
                                :rules="[{ validator: validateAtoms, trigger: 'blur' }]">
                                <div class="atom-tree">
                                    <ul>
                                        <li class="atom-tree-item" :key="i" v-for="(config, i) in form.atoms">
                                            <div class="num">{{ i + 1 }}.</div>
                                            <div class="atom-tree-item-cont">
                                                <div class="choose-atom">
                                                    <el-select v-model="form.atoms[i].atom_id" remote filterable
                                                        :remote-method="onAtomFilterQueryChange"
                                                        @change="onAtomSelected(i)" placeholder="Choose a script">
                                                        <el-option v-for="item in scripts_list" :key="item.value"
                                                            :value="item.value" :label="item.label">{{ item.label
                                                            }}</el-option>
                                                    </el-select>
                                                </div>

                                                <div class="control-tree-item">
                                                    <div class="btn-line">
                                                        <!--
                          <button type="button" class="btn btn-sm btn-icon">
                            <i class="vik vik-arrows-up-down"></i>
                          </button>
                              -->
                                                        <button type="button" class="btn btn-sm btn-icon del"
                                                            v-if="form.atoms.length > 1" @click="removeAtomByIndex(i)">
                                                            <i class="vik vik-delete"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div class="item-cont-group" v-if="varsEnabled[i]">
                                                    <h4 class="tree-title-group">Variables</h4>

                                                    <div class="variables-group">
                                                        <div v-bind:key="v" v-for="(v, idx) in varsExtracted[i]">
                                                            <h5 class="tree-title-variables">{{ v }}</h5>

                                                            <div class="choose-var">
                                                                <el-cascader :options="dataComputed"
                                                                    @change="onCascadeChange(i, idx, v)" v-model="form.atoms[i].variables[idx].var_type
                                                                        "></el-cascader>
                                                            </div>

                                                            <div class="control-var-item"
                                                                v-if="form.atoms[i].variables[idx].var_options">
                                                                <el-input
                                                                    v-if="form.atoms[i].variables[idx].var_options == 'inline/strings'"
                                                                    type="textarea"
                                                                    :autosize="{ minRows: 2, maxRows: 4 }"
                                                                    placeholder="One record per line"
                                                                    v-model="form.atoms[i].variables[idx].var_data"></el-input>
                                                                <div class="item-cont-group"
                                                                    v-if="form.atoms[i].variables[idx].var_options == 'generator/chars'">
                                                                    <div class="form-group">
                                                                        <label>Charset</label>
                                                                        <div class="el-input">
                                                                            <input type="text" autocomplete="off"
                                                                                class="el-input__inner"
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.charset">
                                                                        </div>

                                                                        <el-input></el-input>
                                                                    </div>
                                                                    <div class="form-line">
                                                                        <div class="form-group">
                                                                            <label>Min length</label>
                                                                            <el-input-number
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.min_length"
                                                                                :min="1" :max="500"></el-input-number>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label>Max length</label>
                                                                            <el-input-number
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.max_length"
                                                                                :min="1" :max="500"></el-input-number>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="item-cont-group"
                                                                    v-show="form.atoms[i].variables[idx].var_options == 'generator/randomstring'">
                                                                    <div class="form-group">
                                                                        <label>Charset</label>
                                                                        <div class="el-input">
                                                                            <input type="text" autocomplete="off"
                                                                                class="el-input__inner"
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.charset">
                                                                        </div>
                                                                    </div>
                                                                    <div class="form-line">
                                                                        <div class="form-group">
                                                                            <label>Min length</label>
                                                                            <el-input-number
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.min_length"
                                                                                :min="1" :max="500"></el-input-number>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label for="">Max length</label>
                                                                            <el-input-number
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.max_length"
                                                                                :min="1" :max="500"></el-input-number>
                                                                        </div>
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label for="">Quantity</label>
                                                                        <el-input-number
                                                                            v-model="form.atoms[i].variables[idx].var_options_data.quantity"
                                                                            :min="1" :max="1000000"></el-input-number>
                                                                    </div>
                                                                </div>
                                                                <div class="item-cont-group"
                                                                    v-if="form.atoms[i].variables[idx].var_options == 'generator/numbers'">
                                                                    <div class="form-line">
                                                                        <div class="form-group">
                                                                            <label for="">From</label>
                                                                            <el-input-number
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.min"
                                                                                :min="1" :max="500"></el-input-number>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label for="">To</label>
                                                                            <el-input-number
                                                                                v-model="form.atoms[i].variables[idx].var_options_data.max"
                                                                                :min="1" :max="500"></el-input-number>
                                                                        </div>
                                                                    </div>
                                                                    <div class="form-group">
                                                                        <label for="">Step</label>
                                                                        <el-input-number
                                                                            v-model="form.atoms[i].variables[idx].var_options_data.step"
                                                                            :min="1" :max="1000000"></el-input-number>
                                                                    </div>
                                                                </div>
                                                            </div>




                                                            <!-- <div class="control-var-item" v-if="form.atoms[i].variables[idx].var_has_options
                                  ">
                                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                                    placeholder="One record per line" v-model="form.atoms[i].variables[idx].var_data
                                      "></el-input>
                                </div>
                                {{ form.atoms[i].variables[idx] }} -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="item-cont-group">
                                                    <h4 class="tree-title-group">Threads</h4>
                                                    <el-input-number v-model="form.atoms[i].threads" :min="1"
                                                        :max="150"></el-input-number>
                                                </div>

                                                <div class="item-cont-group" v-if="settingsEnabled[i]">
                                                    <el-form-item label="Settings">
                                                        <div v-bind:key="idx" v-for="(v, idx) in settingsExtracted[i]"
                                                            class="mrg">
                                                            <div class="block33">
                                                                <el-checkbox v-if="v.view == 'checkbox'"
                                                                    v-model="form.atoms[i].settings[idx].value">{{
                                                                        v.title }}</el-checkbox>
                                                                <div v-if="v.view == 'multiselect'">
                                                                    <h4 class="setting-title">{{ v.title }}</h4>
                                                                    <el-select v-model="form.atoms[i].settings[idx].value
                                                                        " filterable multiple allow-create
                                                                        :placeholder="form.atoms[i].settings[idx].title
                                                                            ">
                                                                        <el-option v-for="item in v.value" :value="item"
                                                                            :key="item">{{ item }}</el-option>
                                                                    </el-select>
                                                                </div>
                                                                <div v-if="v.view == 'string'">
                                                                    <h4 class="setting-title">{{ v.title }}</h4>
                                                                    <el-input v-model="v.modelString"></el-input>
                                                                </div>
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </el-form>

                        <div class="form-group">
                            <div class="btn-line">
                                <button type="button" class="btn btn-primary" @click="addAtom">
                                    <i class="vik vik-plus"></i>Add atom
                                </button>
                                <button type="button" class="btn btn-success" @click="save">
                                    <i class="vik vik-save"></i>Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { bus } from "@/bus.js";
import * as utils from "@/utils.js";
// import $ from "jquery";
import AssetsTree from "@/components/internal/AssetsTree";
import _ from "lodash";
// import { SelfBuildingSquareSpinner } from "epic-spinners";
import { getScripts, getTemplate } from "@/api.js";
import { VclList, VclCode } from "vue-content-loading";
import { template } from "lodash";
export default {
    components: { AssetsTree, VclCode, VclList },
    data() {
        return {
            isNew: false,
            form: {
                template_id: "",
                name: "",
                description: "",
                public: false,
                slug: "",
                system: true,
                tags: [],
                atoms: [{ atom_id: "", variables: [], settings: [], threads: 1 }],
                translations: null,
            },
            translations: [],


            preloadedTargets: false,
            formatedTargets: [],
            targetsFilter: "",
            atoms: [],
            lists: [],
            varsEnabled: [false],
            settingsEnabled: [false],
            varsExtracted: [],
            settingsExtracted: [],
            targets_source: [],
            allTargetsChecked: false,
            atomFilterLoading: false,
            showAssetsTree: false,

            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input task name",
                        trigger: "blur",
                    },
                    { min: 1, message: "Length should be 3 to 5", trigger: "blur" },
                ],
            },
            filterMethod(query, item) {
                return item.key.toLowerCase().indexOf(query.toLowerCase()) > -1;
            },
            loadAssets: false,
            targetsLoading: true,
            dt: {},
            varCascade: [],
        };
    },
    mounted() {
        if (this.$route.params.id == 'new') {
            this.isNew = true
        }
        if (!this.isNew)
            this.load()

        this.getAtoms();
        // this.getLists();
        // this.checkHash();
        // this.loadTargets();
    },
    watch: {
        targetsFilter(v) {
            //this.loadTargets();
        },
    },
    methods: {
        async load() {
            let that = this
            getTemplate(this.$route.params.id).then((data) => {
                this.form.template_id = data.Data.template_id
                this.form.name = data.Data.name;
                this.form.description = data.Data.description
                this.form.atoms = data.Data.atoms
                this.form.public = data.Data.public
                this.form.system = data.Data.system
                this.form.slug = data.Data.slug
                this.form.tags = data.Data.tags || []
                
                // Load translations from JSON
                this.translations = [];
                if (data.Data.translations) {
                    try {
                        let translationsObj;
                        if (typeof data.Data.translations === 'string') {
                            translationsObj = JSON.parse(data.Data.translations);
                        } else {
                            translationsObj = data.Data.translations;
                        }
                        // Convert object to array format for the UI
                        for (const [lang, trans] of Object.entries(translationsObj)) {
                            this.translations.push({
                                lang: lang,
                                name: trans.name || "",
                                description: trans.description || "",
                                tags: trans.tags || []
                            });
                        }
                    } catch (e) {
                        console.error("Error parsing translations:", e);
                    }
                }
            });
        },



        validateTargets(rule, value, callback) {
            if (!value || value.length < 1) {
                return callback(new Error("Choose targets"));
            }
            callback();
        },
        validateAtoms(rule, value, callback) {
            console.log("validateAtoms", value)
            // todo: validate atom settings
            // for (var i of value) {
            //     if (i.ID.length < 1) return callback(new Error("Choose atoms"));
            // }
            callback();
        },
        onAtomFilterQueryChange(query) {
            this.atomFilterLoading = true;
            this.getAtoms(query);
            this.atomFilterLoading = false;
        },
        checkHash() {
            if (this.$route.hash) {
                var that = this;
                var lochash = this.$route.hash.substring(1);
                var params = lochash
                    .split("&")
                    .map((v) => v.split("="))
                    .reduce((pre, [key, value]) => ({ ...pre, [key]: value }), {});
                if (params.selectedTargets) {
                    this.preloadedTargets = true;
                    let targetsSlice = params.selectedTargets.split(",");
                    var targetsData = [];
                    let index = 0;
                    let t = [];
                    _.forEach(targetsSlice, function (target) {
                        t.push({
                            title: target,
                            checked: false,
                            expand: false,
                            children: [],
                        });
                    });
                    that.formatedTargets = t;
                }
                if (params.taskName) {
                    that.form.name = unescape(params.taskName);
                }
            } else {
            }
        },
        addAtom() {
            this.form.atoms.push({
                atom_id: "",
                variables: [],
                settings: [],
                threads: 1,
            });
        },
        removeAtomByIndex(index) {
            if (index > -1) {
                this.form.atoms.splice(index, 1);
            }
            // this.form.atoms.splice(-1, 1);
        },
        addTranslation() {
            this.translations.push({
                lang: "",
                name: "",
                description: "",
                tags: []
            });
        },
        removeTranslation(index) {
            if (index > -1) {
                this.translations.splice(index, 1);
            }
        },
        onCascadeChange(hash, var_id, var_name) {
            console.log('onCascadeChange')
            this.form.atoms[hash].variables[var_id].var_name = var_name;
            let d = this.form.atoms[hash].variables[var_id].var_type;
            switch (d[0]) {
                case "inline":
                    switch (d[1]) {
                        case "list":
                            var cloned = Object.assign({}, this.form.atoms[hash]);
                            cloned.variables[var_id].var_has_options = true;
                            cloned.variables[var_id].var_options = "inline/strings"
                            this.$set(this.form.atoms, hash, cloned);
                            break;

                        default:
                            var cloned = Object.assign({}, this.form.atoms[hash]);
                            cloned.variables[var_id].var_has_options = false;
                            this.$set(this.form.atoms, hash, cloned);
                    }
                    break;

                default:
                    // hide var parameters
                    var cloned = Object.assign({}, this.form.atoms[hash]);
                    cloned.variables[var_id].var_has_options = false;
                    this.$set(this.form.atoms, hash, cloned);

                case "generator":
                    switch (d[1]) {
                        case "numbers":
                            var cloned = Object.assign({}, this.form.atoms[hash]);
                            cloned.variables[var_id].var_has_options = true;
                            cloned.variables[var_id].var_options = "generator/numbers"
                            cloned.variables[var_id].var_options_data = {
                                step: 1,
                                min: 100,
                                max: 1000,
                            };
                            this.$set(this.form.atoms, hash, cloned);
                            break;

                        case "chars":
                            var cloned = Object.assign({}, this.form.atoms[hash]);
                            cloned.variables[var_id].var_has_options = true;
                            cloned.variables[var_id].var_options = "generator/chars"
                            cloned.variables[var_id].var_options_data = {
                                charset: "0123456789abcdefghijklmnopqrstuvwxyz",
                                min_length: 2,
                                max_length: 3,
                            }
                            this.$set(this.form.atoms, hash, cloned);

                            break;
                        case "randomstring":
                            var cloned = Object.assign({}, this.form.atoms[hash]);
                            cloned.variables[var_id].var_has_options = true;
                            cloned.variables[var_id].var_options = "generator/randomstring"
                            cloned.variables[var_id].var_options_data = {
                                charset: "0123456789abcdefghijklmnopqrstuvwxyz",
                                min_length: 5,
                                max_length: 10,
                                quantity: 10,
                            }
                            this.$set(this.form.atoms, hash, cloned);

                            break;
                    }

            }
        },
        extractVars(code, start_template, end_template) {
            var re = /{\{[^}\]\[\{}](\w+)\}\}/g;
            let v = code.match(re);
            if (v)
                return v
                    .map((res) => res.replace(/{|}|[|]/g, ""))
                    .filter((v, i, a) => a.indexOf(v) === i);
            else return [];
        },
        onAtomSelected(id) {
            console.log("on select", id, this.form.atoms);
            let atom = this.getAtomInfo(this.form.atoms[id].atom_id);
            console.log("atom", atom);
            let extractedVars = this.extractVars(atom.code);
            this.form.atoms[id].settings = []; // reset
            this.varsEnabled[id] = false; // reset
            this.varsExtracted[id] = []; // reset
            this.settingsEnabled[id] = false; // reset
            this.settingsExtracted[id] = []; // reset
            if (extractedVars != null && extractedVars.length > 0) {
                this.varsEnabled[id] = true;
                this.varsExtracted[id] = extractedVars;
                for (let i in this.varsExtracted[id]) {
                    var var_name = this.varsExtracted[id][i];
                    this.form.atoms[id].variables.push({
                        var_name: "",
                        var_type: [],
                        var_data: "",
                        var_has_options: false,
                    });
                }
            } else {
                this.varsEnabled[id] = false;
                this.varsExtracted[id] = [];
            }
            if (atom.settings.length > 0) {
                try {
                    let settings = atom.settings;
                    if (settings && settings.length > 0) {
                        this.settingsEnabled[id] = true;
                        this.settingsExtracted[id] = settings;
                        for (let i in settings) {
                            let item = settings[i];
                            this.form.atoms[id].settings.push({
                                name: item.name,
                                title: item.title,
                                view: item.view,
                                value: item.value,
                            });
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            }
            // this.form.atoms[id].title = atom.title;
        },
        getAtomInfo(id) {
            // console.log("getAtomInfo", id, this.atoms);
            for (var i in this.atoms) {
                if (this.atoms[i].atom_id == id) {
                    return this.atoms[i];
                }
            }
            return null;
        },
        charsetChanged(a, b, c) {
            console.log(a, b, c)
        },
        getAtoms(query) {
            getScripts((query = query ? query : ""), 1, 50)
                .then((data) => {
                    this.atoms = data.Records;
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        loadTargets() {
            if (this.preloadedTargets) {
                return;
            }
            this.targetsLoading = true;
            let that = this;
            that.targets = [];
            that.targets_source = [];
            utils
                .$get(
                    `/api/assets/tree/?assets=${this.topLevelFilter.toString()}&q=${this.computedTargetsFilter
                    }&limit=50000`
                )
                .then((data) => {
                    // var scopes = Object.assign([], data.scopes);
                    data.scopes.forEach((scope, index) => {
                        scope.assets = [];
                        scope.id = scope.id;
                        scope.type = "scope";
                        scope.expand = false;
                        scope.checked = false;
                    });
                    data.assets.forEach((asset, index) => {
                        for (let i in data.scopes) {
                            if (data.scopes[i].id === asset.scope_id) {
                                // expand asset props...
                                asset.id = asset.id;
                                asset.type = "asset";
                                asset.checked = false;
                                asset.expand = false;
                                data.scopes[i].assets.push(asset);
                            }
                        }
                    });
                    that.formatedTargets = Object.assign([], data.scopes);
                    that.targetsLoading = false;
                    console.timeEnd("loadTargets");
                    // that.renderTargetsForm(targetsData); // old way
                })
                .catch(function (err) {
                    console.log("Fetch Error :-S", err);
                    that.targetsLoading = false;
                });
        },
        getLists() {
            let that = this;
            getFiles("file_type=text/plain") // // file_type=text/plain
                .then((data) => {
                    that.lists = data.Records;
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        save() {
            let that = this;
            // todo: add atoms validation
            this.$refs["templateform"].validate((valid) => {
                if (valid) {
                    console.log("saving template")
                    // Convert translations array to JSON object format
                    const translationsObj = {};
                    this.translations.forEach(trans => {
                        if (trans.lang) {
                            translationsObj[trans.lang] = {
                                name: trans.name || "",
                                description: trans.description || "",
                                tags: trans.tags || []
                            };
                        }
                    });
                    // Only include translations if there are any
                    if (Object.keys(translationsObj).length > 0) {
                        this.form.translations = translationsObj;
                    } else {
                        this.form.translations = null;
                    }
                    
                    utils.$post("/api/templates/save/", this.form).then((data) => {
                        that.$router.push({
                            name: "Templates",
                        });
                        that.form.template_id = data.ID
                        that.$notify.success({
                            title: "Success",
                            message: "Template saved",
                        });
                    }).catch(function (err) {
                        utils.showError(
                            that,
                            "Error",
                            "Failed to create template\n" + err
                        );
                    });
                } else {
                    utils.showError(
                        that,
                        "Error",
                        "Failed to create template\n" + err
                    );
                }
            });
        },
    },
    computed: {
        computedTargetsFilter() {
            return this.targetsFilter;
        },
        scripts_list() {
            console.log(this.atoms);
            var items = [];
            for (var i in this.atoms) {
                items.push({
                    label: this.atoms[i].title,
                    value: this.atoms[i].atom_id, // from atoms API
                });
            }
            return items;
        },
        dataComputed() {
            return [
                {
                    value: "inline",
                    label: "Inline",
                    children: [
                        {
                            value: "list",
                            label: "List",
                        },
                    ],
                },
                {
                    value: "generator",
                    label: "Generators",
                    children: [
                        {
                            // generator/randomstring
                            value: "randomstring",
                            label: "Random string",
                        },
                        {
                            value: "numbers",
                            label: "Numbers",
                        },
                        {
                            value: "chars",
                            label: "Chars",
                        },
                    ],
                },
                {
                    value: "file",
                    label: "Lines from file",
                    children: this.listsComputed,
                },
            ];
        },
        listsComputed() {
            var items = [];
            for (var i in this.lists) {
                items.push({ label: this.lists[i].file_name, value: this.lists[i].id });
            }
            return items;
        },
        topLevelFilter: {
            get: function () {
                return this.loadAssets;
            },
            set: function (v) {
                this.loadAssets = v;
                this.loadTargets();
            },
        },
    },
};
</script>

<style scoped>
.block33 {
    display: table;
    color: #8492a6;
}

.el-input {
    margin-top: 5px;
}

.mrg {
    margin-top: 5px;
}

/* max-height - the only parameter in this file that needs to be edited.
   * Change it to suit your needs. The rest is recommended to leave as is.
   */
.clusterize-scroll {
    max-height: 200px;
    overflow: auto;
}

/**
   * Avoid vertical margins for extra tags
   * Necessary for correct calculations when rows have nonzero vertical margins
   */
.clusterize-extrel-row {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

/* By default extra tag .clusterize-keep-parity added to keep parity of rows.
   * Useful when used :nth-child(even/odd)
   */
.clusterize-extrel-row.clusterize-keep-parity {
    display: none;
}

/* During initialization clusterize adds tabindex to force the browser to keep focus
   * on the scrolling list, see issue #11
   * Outline removes default browser's borders for focused elements.
   */
.clusterize-content {
    outline: 0;
    counter-reset: clusterize-counter;
}

/* Centering message that appears when no data provided
   */
.clusterize-no-data td {
    text-align: center;
}
</style>
<style>
#example_paginate,
#example_length {
    display: none !important;
}

.head-title {
    font-size: 20px;
    font-weight: 400;
    display: inline-block;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
        Microsoft YaHei, \\5fae\8f6f\96c5\9ed1, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #515a6e;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
}

.dts_label {
    display: none;
}

.translations-section {
    width: 100%;
}

.translation-item {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
}

.translation-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.translation-fields {
    margin-top: 15px;
}

.translation-fields .el-form-item {
    margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/SingleTemplate.vue